export default {
  reference: "Dedicated Ref.",
};
